module.exports = __webpack_public_path__ + "img/navantia_logo.d0f3b329.png";